import React, { Component } from "react";
import FlexView from "react-flexview";
import Button from "../../../modules/commons/Button";
import Container from "../../../modules/commons/Container";
import SimpleButton from "../../../modules/commons/SimpleButton";
import { defaultTableChange } from "../../../modules/custom/customTable";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import Api from "../../../Services/Api";
import SimpleDDL from "../../../modules/SimpleDDL";
import { formGroup, tableColumns } from "./config";
import SimpleDate from "../../../modules/SimpleDate";
import M from "moment";
import MasterPartPriceModifying from "./masterPartPriceModifying";
import MasterPartPriceFilter from "./masterPartPriceFilter";
import SimplePrintTable from "../../../modules/popup/SimplePrintTable";
import ErrorAction from "../../../Redux/ErrorRedux";
import { connect } from "react-redux";
import { fetchDataAsync, getUserAccess } from "../../../Services/Utils";
import { HttpStatus } from "../../common/Constants";
import { removeNullFields } from "../../common/mapper";
import SimpleAlert from "../../../modules/popup/SimpleAlert";

class MasterPartPrice extends Component {
  tableColumns = [
    {
      name: "",
      label: "No",
      options: {
        customBodyRender: (_, tableMeta) => {
          const { page, rowsPerPage } = tableMeta.tableState;
          const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

          return <>{rowNumber}</>;
        },
        setCellProps: () => ({
          style: { width: "5%" },
        }),
      },
    },
    ...tableColumns,
    {
      name: "partPriceId",
      label: "Aksi",
      options: {
        customBodyRender: (id) => {
          return (
            <FlexView vAlignContent="center">
              <Button
                className="btnAct"
                disabled={!this.state.userAccess?.updateAccess}
                onClick={() => this.handleUpdatedata(id)}
              >
                <i
                  className="fa fa-lw fa-pencil-alt"
                  style={{
                    backgroundColor: "transparent",
                    color: this.state.userAccess?.updateAccess
                      ? "red"
                      : "black",
                    fontSize: 20,
                  }}
                />
              </Button>
              <Button
                className="btnAct margin-left-15px"
                disabled={!this.state.userAccess?.deleteAccess}
                onClick={() => this.handleDeleteAlertModalVisibility(id)}
              >
                <i
                  className="fa fa-trash"
                  style={{
                    backgroundColor: "transparent",
                    color: this.state.userAccess?.deleteAccess
                      ? "red"
                      : "black",
                    fontSize: 20,
                  }}
                />
              </Button>
            </FlexView>
          );
        },
      },
    },
  ];

  constructor(props) {
    super(props);
    this.state = {
      formGroup: formGroup,
      tableData: [],
      loading: false,
      isModifyingModalVisible: false,
      isFilterModalVisible: false,
      printModalVisible: false,
      kodeCabang: [],
      filterData: {},
      temporaryFilter: {},
      selectedCabang: {},
      paramFilters: {},
      selectedDocument: "",
      displayActive: true,
      limit: 5,
      page: 1,
      totalData: 0,
      userAccess: {},
    };
  }

  async componentDidMount() {
    this.handleTriggerLoading();
    const response = await Api.create(
      "NAGAMAS_MASTER_DATA"
    ).findAllMasterCabang();
    if (response.ok) {
      const filteredData = response.data.data
        .filter((item) =>
          this.props.menuAccess
            .map((data) => data.idRefObj)
            .includes(item.kodeCabang)
        )
        .map(({ kodeCabang, namaDealer }) => ({
          label: namaDealer,
          value: kodeCabang,
        }));
      if (filteredData.length > 0) {
        this.setState((prevValue) => ({
          ...prevValue,
          kodeCabang: filteredData,
          selectedCabang: filteredData[0],
          filterData: {
            kodeCabang: [filteredData[0].value],
            startEffectiveDate: M(new Date()).format("DD-MM-YYYY"),
            endEffectiveDate: M(new Date()).format("DD-MM-YYYY"),
          },
          paramFilters: {
            kodeCabang: [filteredData[0].value],
            startEffectiveDate: M(new Date()).format("DD-MM-YYYY"),
            endEffectiveDate: M(new Date()).format("DD-MM-YYYY"),
          },
        }));
      }
    }
    this.handleTriggerLoading();
  }

  fetchData = async (filter = {}, page = 1, limit = 5) => {
    this.handleTriggerLoading();
    this.setState({ totalData: 0, isFetch: true });

    const payload = {
      partPriceId: filter.partPriceId || null,
      startEffectiveDate: filter.startEffectiveDate || null,
      endEffectiveDate: filter.endEffectiveDate || null,
      mdId: filter.mdId || null,
      listKodeCabang: filter.kodeCabang || [],
      partCode: filter.kodePart || null,
      partName: filter.partName || null,
      limit,
      page,
    };

    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterPartPrice,
      menuName: "Master Part Price",
      setError: this.props.setError,
      args: payload,
    });

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState({
        tableData: res.data.data,
        totalData: res.data.totalData,
        limit,
        page,
      });
    }

    this.setState({ isFetch: false });
    this.handleTriggerLoading();
  };

  componentDidUpdate = async (_, prevState) => {
    if (
      (prevState.page !== this.state.page ||
        prevState.limit !== this.state.limit) &&
      !this.state.isFetch
    ) {
      this.handleTriggerLoading();
      await this.fetchData(
        this.state.paramFilters,
        this.state.page,
        this.state.limit
      );
      this.handleTriggerLoading();
    }

    if (prevState.selectedCabang !== this.state.selectedCabang) {
      this.handleTriggerLoading();
      const updatedFilterData = {
        kodeCabang: [this.state.selectedCabang.value],
        startEffectiveDate: M(new Date()).format("DD-MM-YYYY"),
        endEffectiveDate: M(new Date()).format("DD-MM-YYYY"),
      };
      let userAccess = getUserAccess(
        this.props.menuAccess,
        this.state.selectedCabang.value
      );
      this.setState((prevValue) => ({
        ...prevValue,
        userAccess: userAccess,
        filterData: updatedFilterData,
        paramFilters: updatedFilterData,
        temporaryFilter: {},
      }));
      await this.fetchData(updatedFilterData);
      this.handleTriggerLoading();
    }
  };

  // handleDelete = async (id) => {
  //   await this.setState((prevValue) => ({
  //     ...prevValue,
  //     displayActive: !prevValue.displayActive,
  //     selectedDocument: id,
  //   }));
  //   this.handleModifyingModalVisibility();
  // };

  handleDeleteAlertModalVisibility = (id) => {
    const text = "Apakah anda yakin ingin menghapus data ini ?";
    this.setState((prevState) => ({
      ...prevState,
      warningMessage: text,
      deleteAlert: !prevState.deleteAlert,
      displayActive: !prevState.displayActive,
      selectedId: id,
      isModifyingModalVisible: false,
    }));
  };

  handleChangePage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      page: tableState.page + 1,
    }));
  };

  handleRowsPerPage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      page: 1,
      totalData: 0,
      limit: tableState.rowsPerPage,
    }));
  };

  handleValueChange = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
      page: 1,
      limit: 5
    }));
  };

  handleInputDateChange = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      filterData: {
        ...prevValue.filterData,
        [name]: M(value).format("DD-MM-YYYY"),
      },
    }));
  };

  handleOnSubmitFilterSearch = async () => {
    this.handleTriggerLoading();
    let updatedFilterData;
    await this.setState((prevValue) => {
      updatedFilterData = {
        ...prevValue.filterData,
        kodeCabang: [this.state.selectedCabang.value],
      };
      return {
        ...prevValue,
        filterData: updatedFilterData,
        paramFilters: updatedFilterData,
        temporaryFilter: {},
      };
    });
    await this.fetchData(updatedFilterData);
    this.handleTriggerLoading();
  };

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  handleUpdatedata = (id) => {
    this.setState(
      (prevValue) => ({
        ...prevValue,
        selectedDocument: id,
      }),
      () => {
        this.handleModifyingModalVisibility();
      }
    );
  };

  handleModifyingModalVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      isModifyingModalVisible: !prevValue.isModifyingModalVisible,
    }));
  };

  handleSubmitData = async (data) => {
    this.handleTriggerLoading();
    if (this.state.displayActive) {
      let res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").createMasterPartPrice,
        menuName: "Master Part Price",
        setError: this.props.setError,
        args: data,
      });
      if (res.ok && res.data.status === HttpStatus.SUCCESS) {
        this.handleModifyingModalVisibility();
        await this.refetch();
        this.handleTriggerLoading();
        return;
      }
    } else {
      let res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").deleteMasterPartPrice,
        menuName: "Master Part Price",
        setError: this.props.setError,
        args: data,
      });
      if (res.ok && res.data.status === HttpStatus.SUCCESS) {
        this.handleDeleteAlertModalVisibility();
        await this.refetch();
        this.handleTriggerLoading();
        return;
      }
      this.setState((prevValue) => ({
        ...prevValue,
        displayActive: !prevValue.displayActive,
      }));
    }
    this.setState((prevValue) => ({
      ...prevValue,
      selectedDocument: "",
    }));
    this.handleTriggerLoading();
  };

  handleFilterVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      isFilterModalVisible: !prevValue.isFilterModalVisible,
    }));
  };

  refetch = async () => {
    const updatedFilterData = {
      kodeCabang: [this.state.selectedCabang.value],
      startEffectiveDate: M(new Date()).format("DD-MM-YYYY"),
      endEffectiveDate: M(new Date()).format("DD-MM-YYYY"),
    };
    this.setState((prevValue) => ({
      ...prevValue,
      filterData: updatedFilterData,
      paramFilters: updatedFilterData,
      temporaryFilter: {},
    }));
    await this.fetchData(updatedFilterData);
  };

  // handleFilterInput = async (data) => {
  //   this.handleTriggerLoading();
  //   this.setState((prevValue) => ({
  //     ...prevValue,
  //     temporaryFilter: data,
  //     paramFilters: data,
  //     filterData: {},
  //   }));
  //   await this.fetchData(data);

  //   this.handleFilterVisibility();
  //   this.handleTriggerLoading();
  // };

  handleFilterInput = async (data) => {
    this.handleTriggerLoading();
    const isEmptyFilter = !data || Object.keys(data).length === 0;
    const finalFilter = isEmptyFilter
      ? {
          kodeCabang: [this.state.selectedCabang.value],
          // startEffectiveDate: M(new Date()).format("DD-MM-YYYY"),
          // endEffectiveDate: M(new Date()).format("DD-MM-YYYY"),
        }
      : data;

    this.setState((prevValue) => ({
      ...prevValue,
      temporaryFilter: data,
      paramFilters: finalFilter,
      filterData: {},
    }));

    await this.fetchData(finalFilter);
    this.handleFilterVisibility();
    this.handleTriggerLoading();
  };

  handleDisplatActive = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      selectedDocument: "",
      displayActive: true,
    }));
  };

  // handleResetFilter = () => {
  //   this.setState((prevValue) => ({
  //     ...prevValue,
  //     temporaryFilter: {},
  //     paramFilters: prevValue.filterData,
  //   }));
  // };

  handleResetFilter = async () => {
    const { selectedCabang } = this.state;

    const resetFilterData = {
      kodeCabang: [selectedCabang?.value],
      startEffectiveDate: null,
      endEffectiveDate: null,
    };

    this.setState((prev) => ({
      ...prev,
      filterData: resetFilterData,
      paramFilters: resetFilterData,
      temporaryFilter: {},
    }));

    await this.fetchData(resetFilterData);
  };

  handlePrint = async () => {
    // this.handleTriggerLoading();
    // try {
    //   const res = await Api.create("NAGAMAS_MASTER_DATA").getTemplateExcelMasterPartPrice();
    //   console.log(res);
    //   if (res.ok) {
    //     const blob = new Blob([res.data], {
    //       type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    //     });
    //     saveAs(blob, "RECEIVING_UNIT_DGI.xlsx");
    //   }
    // } catch (error) {
    //   console.log(error);
    // }
    // this.handleTriggerLoading();
  };

  render() {
    return (
      <>
        <Container>
          <div className="margin-top-5px margin-bottom-20px">
            <SimpleDDL
              id="select_options_nama_cabang"
              box="search"
              name="s"
              containerclassname="width width-250px"
              placeholder="Nama cabang hak akses"
              options={this.state.kodeCabang}
              value={this.state.selectedCabang}
              onChange={(value) => {
                this.handleValueChange("selectedCabang", value);
              }}
            />
          </div>
          <FlexView
            style={{ justifyContent: "space-between", alignItems: "center" }}
            className="margin-bottom-20px margin-top-5px"
          >
            <FlexView vAlignContent="center" style={{ gap: "15px" }}>
              <h3 className="padding-bottom-10px">Periode</h3>
              <SimpleDate
                id="select_date_from"
                // nextdate
                // maxDate={this.state.filterData?.endEffectiveDate}
                date={this.state.filterData?.startEffectiveDate}
                onChange={(value) =>
                  this.handleInputDateChange("startEffectiveDate", value)
                }
              />
              <p className="margin-bottom-20px" style={{ textAlign: "center" }}>
                To
              </p>
              <SimpleDate
                id="select_date_to"
                backdate
                minDate={this.state.filterData?.startEffectiveDate}
                date={this.state.filterData?.endEffectiveDate}
                onChange={(value) =>
                  this.handleInputDateChange("endEffectiveDate", value)
                }
              />
              <SimpleButton
                className="margin-bottom-15px"
                text="Cari"
                onClick={this.handleOnSubmitFilterSearch}
              />
            </FlexView>
            <Button
              type="button"
              className="btn background-red margin-bottom-15px"
              onClick={this.handleFilterVisibility}
            >
              <span>
                <i className="fa fa-qrcode"></i>
              </span>
            </Button>
          </FlexView>
          <SimpleDataTable
            data={this.state.tableData}
            columns={this.tableColumns}
            toCount={this.state.totalData}
            rowsPerPage={this.state.limit}
            page={this.state.page - 1}
            options={defaultTableChange(
              this.handleChangePage,
              this.handleRowsPerPage
            )}
            footerAdditionalButtons={
              <>
                <SimpleButton
                  onClick={() => this.handleModifyingModalVisibility()}
                  secondary={
                    !this.state.userAccess?.createAccess ? true : false
                  }
                  disabled={!this.state.userAccess?.createAccess}
                >
                  <span>
                    <i className="fa fa-plus margin-right-10px"></i>
                  </span>
                  Tambah
                </SimpleButton>
                {/* <SimpleButton secondary onClick={this.handlePrint}>
                  Cetak
                </SimpleButton> */}
              </>
            }
          />
          <SimpleLoadingOverlay active={this.state.loading} />
        </Container>
        {this.state.isModifyingModalVisible && (
          <MasterPartPriceModifying
            {...this.props}
            id={this.state.selectedDocument}
            visible={this.state.isModifyingModalVisible}
            onClose={this.handleModifyingModalVisibility}
            onSubmit={this.handleSubmitData}
            kodeCabang={this.state.selectedCabang}
            optionCabang={this.state.kodeCabang}
            displayActive={this.state.displayActive}
            handleDisplatActive={this.handleDisplatActive}
          />
        )}
        {this.state.isFilterModalVisible && (
          <MasterPartPriceFilter
            {...this.props}
            visible={this.state.isFilterModalVisible}
            temporaryFilter={this.state.temporaryFilter}
            onClickClose={this.handleFilterVisibility}
            onSubmit={this.handleFilterInput}
            onReset={this.handleResetFilter}
            kodeCabang={this.state.kodeCabang}
            selectedCabang={this.state.selectedCabang}
          />
        )}

        {this.state.deleteAlert && (
          <SimpleAlert
            title={"Information"}
            content={
              <div>
                <p>{this.state.warningMessage}</p>
              </div>
            }
            visible={this.state.deleteAlert}
            onClickClose={this.handleDeleteAlertModalVisibility}
            additionalButtons={
              <FlexView vAlignContent="center" style={{ alignItems: "end" }}>
                <SimpleButton
                  type="button"
                  text="Batal"
                  onClick={() => this.handleDeleteAlertModalVisibility()}
                />
                <SimpleButton
                  type="button"
                  text="OK"
                  onClick={() => this.handleSubmitData(this.state.selectedId)}
                />
              </FlexView>
            }
          />
        )}

        {this.state.printModalVisible && (
          <SimplePrintTable onClearPrint={this.handlePrint} />
        )}
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (payload) => dispatch(ErrorAction.setError(payload)),
  };
};

export default connect(null, mapDispatchToProps)(MasterPartPrice);
